export enum ContentTypesEnum {
  Image,
  Video,
  DocumentFile,
  CompressedFile,
  Vote,
  Exam,
  Online,
  VirtualLab,
  Game,
  Scorm,
  Text,
  Label,
  Assignment,
  PDFDocument,
  OnsiteSession
}
